<template>
    <div :class="'right_menu right_menu_' + theme"
        :style="{ width: itemSize.width + 'px', top: setting.y + 'px', left: setting.x + 'px' }" v-show="setting.status">
        <div v-for="(item, index) in data" :key="'a'+index">
            <RightMenuItem :data="item" :theme="theme" :top="setting.y + index * itemSize.height" :left="setting.x" :item-size="itemSize"></RightMenuItem>
            <div v-if="item.outline" :class="'right_menu_outline right_menu_outline_' + theme"></div>
        </div>
    </div>
</template>
 
<script>
import RightMenuItem from "./rightMenuItem";
export default {
    name: "RightMenuList",
    components: { RightMenuItem },
    props: {
        data: Array,
        theme: String,
        setting: Object,
        itemSize: Object,
    },
    mounted() {
        /**
         * 统一关闭入口
         */
        // this.$event.$on("RightMenuListClose", () => {
        //     if (this.$parent.closeChild) this.$parent.closeChild();
        // });
    },
    methods: {
        close() {
            this.$parent.close();
        },
    },
}
</script>
 
<style scoped>
.right_menu {
    box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.3);
    position: fixed;
    padding: 4px 2px;
}

.right_menu_light {
    background: #f3f3f3;
}

.right_menu_dark {
    border: 1px solid #bbbbbb;
    background: #282828;
}

.right_menu_outline {
    width: 90%;
    height: 1px;
    margin: 3px 0 3px 5%;
}

.right_menu_outline_light {
    background: #aaaaaa;
}

.right_menu_outline_dark {
    background: #bbbbbb;
}
</style>